import React, { useEffect } from "react";
import "./PropertyList.css";
import column from "../../Images/Vector (9).png";
import grid from "../../Images/Group 1171279337.png";
import grid2 from "../../Images/Group 1171279337 (1).png";
import dropdown from "../../Images/Vector (8).png";
import { useState } from "react";

import PropertyTable from "./PropertyTable";
import PropertyGrid from "./PropertyGrid";
import PropertyColumn from "./PropertyColumn";
import Header2 from "../../Layout/Header2";
import Header from "../../Layout/Header";
import Sidebar from "../../Layout/Sidebar";
import img from "../../Images/low-angle-view-blue-white-modern-buildings-cloudy-sky 1 (1).png";
import HomeService from "../../Services/HomeService";
import { data, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import WhatsAppButton from "../../Component/WhatsAppButton";

const ActivePropertyList = () => {
  const [progress, setProgress] = useState(0);
  const [toggle, settoggle] = useState(2);
  const [show, setshow] = useState(false);
  const [index, SetIndex] = useState();

  const location = useLocation();
  console.log("YTT28", location?.state?.data);

  const [filterData, setFilterData] = useState({
    userId: "",
    // cityId: location?.state?.data?.city || "",
    // propertyType: location?.state?.data?.propertyType || "",
    // locality: location?.state?.data?.locality || "",
    cityId: "",
    propertyType: "",
    propertyFor: "",
    locality: "",
    address: "",
    area: "",
    bhk: "",
    floor: "",
    priceRange: progress, //in lakhs bydefalut
  });

  const [propertyType, setPropertyType] = useState([]);
  const [bhk, setbhk] = useState([]);
  const [floor, setFloor] = useState([]);
  const [city, setCity] = useState([]);
  const [userId, setUserId] = useState("");
  const [submittedData, setSubmittedData] = useState(null);
  const [propertyData, setPropertyData] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [loading, setLoading] = useState(false);

  // console.log("SDV50", submittedData);

  // const _fetchAllProperty = async (id) => {
  //   console.log("URY45", id);
  //   try {
  //     const response = await HomeService.getProperties({ userId: id });
  //     // console.log({ userId });
  //     console.log("UYT49", response.data);

  //     setPropertyData(response.data || []);

  //     // const priceRange = progress === 0 ? "" : `0-${progress}`;
  //     const priceRange = progress > 0 ? `${progress}` : ""
  //     const data = {
  //       // userId: id,
  //       // cityId: response.data[0].city?._id,
  //       // propertyType: response.data[0]?.propertytype?.propertyType,
  //       // locality: response.data[0]?.locality?.name,
  //       // address: response.data[0]?.address,
  //       // area: response.data[0]?.area,
  //       // bhk: response.data[0]?.bhk,
  //       // floor: response.data[0]?.floor,
  //       // priceRange: progress,

  //       userId: userId,
  //       cityId: response.data[0].cityId,
  //       propertyType: response.data[0].propertyType,
  //       locality: response.data[0].locality,
  //       address: response.data[0].address,
  //       area: response.data[0].area,
  //       bhk: response.data[0].bhk,
  //       floor: response.data[0].floor,
  //       price: priceRange,
  //     };

  //     console.log("ERR67", response.data[0], data);

  //     setSubmittedData(data)

  //   } catch (error) {
  //     console.error("Error fetching properties:", error);
  //   }
  // };

  const fetchAllProperty = async (
    uid,
    city,
    locality,
    propertyType,
    propertyFor,
    multi,
  ) => {
    console.log("HGF103", multi);

    setLoading(true);
    // const priceRange = progress === 0 ? "" : `0-${progress}`;
    // const priceRange = progress > 0 ? `${progress}` : ""
    const data = {
      userId: uid,
      cityId: city,
      propertyType: propertyType,
      propertyFor: propertyFor,
      locality: locality,
      // address: filterData.address,
      // area: filterData.area,
      // bhk: filterData.bhk,
      // floor: filterData.floor,
      // price: priceRange,
    };

    city &&
      setFilterData({
        ...filterData,
        cityId: city,
        propertyType: propertyType,
        locality: locality,
      });
    console.log("VGT195", data);

    const response = await HomeService.getPropertyList(data);
    console.log("SER154", response.data);
    if (!response?.status) {
      // toast.error(response?.message)
    }
    let filteredProperties = response.data;

    if (multi.localities) {
      filteredProperties = response.data.filter((property) =>
        multi?.localities.includes(property.locality?._id),
      );
    }

    if (multi.propertyTypes) {
      filteredProperties = response.data.filter((property) =>
        multi?.propertyTypes.includes(property.propertytype?._id),
      );
    }

    filteredProperties = response.data.filter((property) => {
      const matchLocality =
        !multi.localities || multi.localities.includes(property.locality?._id);
      const matchPropertyType =
        !multi.propertyTypes ||
        multi.propertyTypes.includes(property.propertytype?._id);
      return matchLocality && matchPropertyType;
    });
    console.log("KJH153", filteredProperties);

    setSubmittedData(
      filteredProperties.filter((item) => item?.status === true),
    );
    // if (response.data.length === 0) {
    //   console.log("getProperty List ", response.data);
    //   setSubmittedData([]);
    // }
    setLoading(false);
  };

  // useEffect(() => {
  //   fetchAllProperty(userId);
  // }, [userId]);

  const [countSubscribedCities, setCountSubscribedCities] = useState(1);
  const fetchCity = async (data) => {
    try {
      const res = await HomeService.getCities(data);
      if (res?.status) {
        const subscribedLocations = res.data.filter(
          (loc) => loc.isSubscribedByUser,
        );

        const subscribedCount = subscribedLocations.length;

        const subscribedIds = subscribedLocations.map((loc) => loc._id);
        console.log("SDX102", subscribedCount, subscribedIds);

        setCountSubscribedCities(subscribedCount);
        setFilterData({ ...filterData, cityId: subscribedIds[0] });
        setCity(res.data);
      }
    } catch (error) {
      console.error("Error fetching city:", error);
    }
  };

  const [subscribedLocalities, setSubscribedLocalities] = useState([]);
  const fetchLocality = async (id) => {
    try {
      const res = await HomeService.getLocalitiesByCity(id);
      console.log("CDE168", res?.data);
      if (res?.status) {
        setLocalities(res?.data);
        const subscribedIds = res?.data
          .filter((item) => item.isSubscribedByUser === true)
          .map((item) => item._id);
        setSubscribedLocalities(subscribedIds);
      }
    } catch (error) {
      console.error("Error fetching property types:", error);
    }
  };

  const [subscribedPropertyTypes, setSubscribedPropertyTypes] = useState([]);
  const fetchPropertyType = async () => {
    try {
      const res = await HomeService.getPropertyTypes();
      if (res?.status) {
        console.log("HGF180", res.data);
        setPropertyType(res.data);
        const subscribedIds = res?.data
          .filter((item) => item.isSubscribedByUser === true)
          .map((item) => item._id);
        setSubscribedPropertyTypes(subscribedIds);
      }
    } catch (error) {
      console.error("Error fetching property types:", error);
    }
  };

  const fetchBhk = async () => {
    try {
      const res = await HomeService.getBhks();
      if (res?.status) {
        setbhk(res.data);
      }
    } catch (error) {
      console.error("Error fetching bhk:", error);
    }
  };
  const fetchFloor = async () => {
    try {
      const res = await HomeService.getFloors();
      if (res?.status) {
        setFloor(res.data);
      }
    } catch (error) {
      console.error("Error fetching floor:", error);
    }
  };
  const fetchBanner = async () => {
    try {
      const res = await HomeService.getBanner();
      if (res?.status) {
        // console.log("all banner", res.data);
      }
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setProgress(value);
    // console.log("this is progress", progress);

    setFilterData((prevData) => ({
      ...prevData,
      priceRange: `0-${progress}`,
    }));
    // console.log("this is filterdata after price change", filterData);
  };
  const handleClearAll = () => {
    // console.log("clear all is clicked");
    setFilterData({
      userId: "",
      cityId: "",
      propertyType: "",
      propertyFor: "",
      locality: "",
      address: "",
      area: "",
      bhk: "",
      floor: "",
      priceRange: "", //in lakhs bydefalut
    });
  };

  const handleSubmit = async (e, city = "") => {
    e.preventDefault();
    // const priceRange = progress === 0 ? "" : `0-${progress}`;
    const priceRange = progress > 0 ? `${progress}` : "";
    const data = {
      userId: userId,
      cityId: city || filterData.cityId,
      propertyType: filterData.propertyType,
      propertyFor: filterData.propertyFor,
      locality: filterData.locality,
      address: filterData.address,
      area: filterData.area,
      bhk: filterData.bhk,
      floor: filterData.floor,
      price: priceRange,
    };

    city && setFilterData({ ...filterData, cityId: city });
    console.log("VGT195", data);

    const response = await HomeService.getPropertyList(data);
    console.log("SER154", response.data);
    if (!response?.status) {
      // toast.error(response?.message)
    }
    setSubmittedData(response.data);
    // if (response.data.length === 0) {
    //   console.log("getProperty List ", response.data);
    //   setSubmittedData([]);
    // }
  };

  const [searchDataOnTheGo, setSearchDataOnTheGo] = useState({});
  const handleSearchOnTheGo = async (e, searchData) => {
    e.preventDefault();
    // return
    // Merge the previous data with the new searchData
    const updatedSearchData = {
      ...searchDataOnTheGo,
      ...searchData,
    };

    // Update the session variable with the merged object
    setSearchDataOnTheGo(updatedSearchData);

    console.log("KJL312", progress);

    // const priceRange = progress === 0 ? "" : `0-${progress}`;
    const priceRange = progress > 0 ? `${progress}` : "";
    const data = {
      userId: userId,
      cityId: updatedSearchData.cityId || filterData.cityId,
      propertyType: updatedSearchData.propertyType,
      propertyFor: updatedSearchData.propertyFor,
      locality: updatedSearchData.locality,
      address: updatedSearchData.address,
      area: updatedSearchData.area,
      bhk: updatedSearchData.bhk,
      floor: updatedSearchData.floor,
      price: priceRange,
    };

    // city && setFilterData({ ...searchDataOnTheGo, cityId: city })
    console.log("CXS339", data);

    // return
    const response = await HomeService.getPropertyList(data);
    console.log("SER154", response.data);
    if (!response?.status) {
      // toast.error(response?.message)
    }
    setSubmittedData(response.data);
    // if (response.data.length === 0) {
    //   console.log("getProperty List ", response.data);
    //   setSubmittedData([]);
    // }
  };

  const navigate = useNavigate();

  const getLoginProfile = async () => {
    const res = await HomeService.getLoginProfile();
    console.log("YTR170", res);

    if (!res.status) {
      navigate("/profile");
    }
    if (res?.status) {
      setUserId(res?.data?._id);

      const cityIds = res?.data?.multiSubscribedCities.map((item) => item._id);
      const localityIds = res?.data?.multiSubscribedLocalities.map(
        (item) => item._id,
      );
      const propertyTypeIds = res?.data?.multiSubscribedPropertyTypes.map(
        (item) => item._id,
      );

      const multi = {
        localities: localityIds,
        propertyTypes: propertyTypeIds,
      };

      console.log("VFT317", multi);

      // setUserCity(res?.data?.city);
      // setUserCitys(res?.data?.miltiCities)
      // setUserCitys(["6801ddfa287196a7f7250e59", "67938940a1d10a99391c00cd", "67ffbc34287196a7f724fe19"])
      // const subscribedIds = res?.data
      //   .filter(location => location.isSubscribedByUser)
      //   .map(location => location._id);

      // console.log("JHGF228",subscribedIds)
      // setUserCitys(subscribedIds)

      // setFilterData({ ...filterData, cityId: res?.data?.city })
      // setFilterData({ ...filterData, cityId: res?.data?.city || res?.data?.multiSubscribedCities[0]?._id })

      fetchLocality(
        location?.state?.data?.city || res?.data?.multiSubscribedCities[0]?._id,
      );
      fetchAllProperty(
        res?.data?._id,
        location?.state?.data?.city || res?.data?.multiSubscribedCities[0]?._id,
        location?.state?.data?.locality || "",
        location?.state?.data?.propertyType || "",
        "",
        multi,
      );
      // fetchAllProperty(res?.data?._id);
    }
  };

  // useEffect(() => {
  //   getLoginProfile();

  //   window.scrollTo({ top: 0, behavior: "instant" });
  // }, []);

  useEffect(() => {
    filterData?.cityId ? fetchLocality(filterData?.cityId) : setLocalities([]);
  }, [filterData?.cityId]);

  useEffect(() => {
    fetchCity({ userId: userId });

    fetchPropertyType();
    // console.log("propertype", propertyType);

    // fetchBhk();
    // console.log("bhk", bhk);

    // fetchFloor();
    // console.log("floor", floor);
    // console.log("pricerange", progress);
  }, [progress, userId]);

  useEffect(() => {
    // location?.state?.data?.city && fetchLocality(location?.state?.data?.city)
    setFilterData({
      // ...filterData,
      cityId: location?.state?.data?.city,
      propertyType: location?.state?.data?.propertyType,
      locality: location?.state?.data?.locality,
    });
  }, [location?.state?.data]);

  useEffect(() => {
    fetchBanner();
    fetchPropertyType();
    getLoginProfile();
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  console.log("KJH393", filterData);
  const availableFor = [
    {
      name: "Sales",
      value: "sales",
    },
    {
      name: "Rent",
      value: "rent",
    },
  ];

  return (
    <>
      <WhatsAppButton phoneNumber="918009903561" textMessge="Hello" />
      <Header />
      {/* <Header2 /> */}
      {/* <Sidebar /> */}
      <div
        className="uni_wrapper bg"
        // style={{
        //   display: 'flex',
        //   justifyContent: 'center',

        // }}
      >
        <div
          className="uni_container5"
          // style={{
          //   width: '100%',
          //   maxWidth: '80%',
          //   minWidth: '80%'
          // }}
        >
          <div className="property_list_screen_div">
            <div className="coulmn_row_div_wrapper">
              <div
                className="column_row_div"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="column_div55" onClick={() => setshow(!show)}>
                  <div className="column_div ">
                    <i class="fa-solid fa-filter"></i>
                  </div>
                </div>

                <div
                  style={{
                    columnGap: "15px",
                  }}
                  className="d-flex justify-content-start align-items-center"
                >
                  <div
                    onClick={(e) => {
                      settoggle(1);
                    }}
                    className={toggle == 1 ? "column_div" : " row_div"}
                  >
                    <img
                      style={{
                        width: "100%",
                        maxWidth: "70%",
                        minWidth: "70%",
                      }}
                      src={column}
                    ></img>
                  </div>
                  <div
                    onClick={(e) => {
                      settoggle(2);
                    }}
                    className={toggle == 1 ? "row_div" : "column_div"}
                  >
                    {toggle == 1 && (
                      <img
                        style={{
                          width: "100%",
                          maxWidth: "85%",
                          minWidth: "85%",
                        }}
                        src={grid}
                      ></img>
                    )}
                    {toggle == 2 && (
                      <img
                        style={{
                          width: "100%",
                          maxWidth: "70%",
                          minWidth: "70%",
                        }}
                        src={grid2}
                      ></img>
                    )}
                  </div>
                </div>

                {/* {
                  city.map((item, key) => {
                    return (
                      <>
                        <div class="column_div"
                          style={{
                            maxWidth: "fit-content",
                            padding: "15px",
                            cursor: item.isSubscribedByUser ? "pointer" : "default",
                            border: "solid 1px #023269",
                            background: item.isSubscribedByUser ? "#023269" : "auto",
                            color: item.isSubscribedByUser ? "#ffffff" : "#023269"
                          }}

                          onClick={(e) => {
                            item.isSubscribedByUser && handleSubmit(e, item._id)
                          }}

                        >{!item.isSubscribedByUser && <><i class="fa-solid fa-lock" style={{ color: "#023269" }}></i>&nbsp;</>}{item.name}</div>
                      </>
                    )
                  })
                } */}
              </div>
            </div>

            <div className="property_list_div_wrapper">
              {toggle == 1 ? (
                <PropertyColumn
                  propertyData={submittedData}
                  loading={loading}
                  showFav={false}
                  activeData={true}
                />
              ) : (
                <PropertyGrid
                  propertyData={submittedData}
                  loading={loading}
                  showFav={false}
                  activeData={true}
                />
              )}

              {/* {propertyData.length > 0 || submittedData.length > 0 ? ( */}
              <div
                className="filter_property_div"
                style={{
                  display: "none",
                }}
              >
                {/* <div className="filter_div_head">
                  <p className="filter_by_para">Filter by</p>
                  <p
                    className="clear_all_para"
                    style={{ cursor: "pointer" }}
                    onClick={handleClearAll}
                  >
                    Clear All
                  </p>
                </div> */}

                <div className="property_filter_form_wrapper">
                  <form>
                    {countSubscribedCities > 1 && (
                      <>
                        <div className="form_field_property">
                          <label className="filter_property_label">City</label>
                          <div className="filter_input_div">
                            <select
                              name="cityId"
                              id="cityId"
                              value={filterData?.cityId || ""}
                              className="filter_input"
                              // onChange={(e) => {
                              //   setFilterData((prevData) => ({
                              //     ...prevData,
                              //     cityId: e.target.value,
                              //   }));
                              // }}
                              onChange={(e) => {
                                const value = e.target.value;
                                setFilterData((prevData) => ({
                                  ...prevData,
                                  cityId: value,
                                }));
                                handleSearchOnTheGo(e, { cityId: value });
                              }}
                            >
                              <option value="">Select City</option>
                              {city
                                .filter((item) => item?.isSubscribedByUser)
                                .map((type) => (
                                  <option key={type?._id} value={type?._id}>
                                    {type?.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Property Type
                      </label>
                      <div className="filter_input_div">
                        {/* <select
                            name="propertyType"
                            id="propertyType"
                            value={filterData?.propertyType || ""}
                            className="filter_input"
                            onChange={(e) => {
                              setFilterData((prevData) => ({
                                ...prevData,
                                propertyType: e.target.value,
                              }));
                            }}
                          >
                            <option value="">Select Property Type</option>
                            {propertyType.map((type) => (
                              <option key={type?._id} value={type?._id}>
                                {type?.propertyType}
                              </option>
                            ))}
                          </select> */}
                        <select
                          name="propertyType"
                          id="propertyType"
                          value={
                            filterData?.propertyType ||
                            searchDataOnTheGo?.propertyType ||
                            ""
                          }
                          className="filter_input"
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     propertyType: e.target.value,
                          //   })
                          //   );
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              propertyType: value,
                            }));
                            handleSearchOnTheGo(e, { propertyType: value });
                          }}
                        >
                          <option value="">Select Property Type</option>
                          {propertyType.map((type) => (
                            <option
                              key={type._id}
                              value={type._id}
                              disabled={type.isSubscribedByUser ? false : true}
                            >
                              {/* {type.isSubscribed ? "🔒 " : "🔒 "} */}
                              {type.propertyType}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Available For
                      </label>
                      <div className="filter_input_div">
                        {/* <select
                            name="propertyType"
                            id="propertyType"
                            value={filterData?.propertyType || ""}
                            className="filter_input"
                            onChange={(e) => {
                              setFilterData((prevData) => ({
                                ...prevData,
                                propertyType: e.target.value,
                              }));
                            }}
                          >
                            <option value="">Select Property Type</option>
                            {propertyType.map((type) => (
                              <option key={type?._id} value={type?._id}>
                                {type?.propertyType}
                              </option>
                            ))}
                          </select> */}
                        <select
                          name="propertyType"
                          id="propertyType"
                          value={
                            filterData?.propertyFor ||
                            searchDataOnTheGo?.propertyFor ||
                            ""
                          }
                          className="filter_input"
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     propertyType: e.target.value,
                          //   })
                          //   );
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              propertyFor: value,
                            }));
                            handleSearchOnTheGo(e, { propertyFor: value });
                          }}
                        >
                          <option value="">Select Property For</option>
                          {availableFor.map((type, key) => (
                            <option key={key} value={type.value}>
                              {type.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form_field_property">
                      <label className="filter_property_label">Locality</label>
                      <div className="filter_input_div">
                        <select
                          name="locality"
                          id="locality"
                          value={filterData?.locality || ""}
                          className="filter_input"
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     locality: e.target.value,
                          //   }));
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              locality: value,
                            }));
                            handleSearchOnTheGo(e, { locality: value });
                          }}
                        >
                          <option value="">Select Locality</option>
                          {localities.map((type) => (
                            <option
                              key={type?._id}
                              value={type?._id}
                              disabled={type.isSubscribedByUser ? false : true}
                            >
                              {!type.isSubscribedByUser && <>&nbsp;</>}
                              {type?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form_field_property">
                      <label className="filter_property_label">
                        Socity name / Address
                      </label>
                      <div className="filter_input_div">
                        <input
                          className="filter_input"
                          placeholder="Select an option"
                          value={filterData.address}
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     address: e.target.value,
                          //   }));
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              address: value,
                            }));
                            handleSearchOnTheGo(e, { address: value });
                          }}
                        ></input>
                        {/* <img src={dropdown}></img> */}
                      </div>
                    </div>

                    <div className="form_field_property">
                      <label className="filter_property_label">Area</label>
                      <div className="filter_input_div">
                        <input
                          className="filter_input"
                          placeholder="Select an option"
                          value={filterData.area}
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     area: e.target.value,
                          //   }));
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              area: value,
                            }));
                            handleSearchOnTheGo(e, { area: value });
                          }}
                        ></input>
                        {/* <img src={dropdown}></img> */}
                      </div>
                    </div>

                    <div className="form_field_property">
                      <label className="filter_property_label">BHK</label>
                      <div className="filter_input_div">
                        <input
                          className="filter_input"
                          placeholder="Select an option"
                          value={filterData.bhk}
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     bhk: e.target.value,
                          //   }));
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              bhk: value,
                            }));
                            handleSearchOnTheGo(e, { bhk: value });
                          }}
                        ></input>
                      </div>
                    </div>

                    <div className="form_field_property">
                      <label className="filter_property_label">Floor</label>
                      <div className="filter_input_div">
                        <input
                          className="filter_input"
                          placeholder="Select an option"
                          value={filterData.floor}
                          // onChange={(e) => {
                          //   setFilterData((prevData) => ({
                          //     ...prevData,
                          //     floor: e.target.value,
                          //   }));
                          // }}
                          onChange={(e) => {
                            const value = e.target.value;
                            setFilterData((prevData) => ({
                              ...prevData,
                              floor: value,
                            }));
                            handleSearchOnTheGo(e, { floor: value });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="form_field_property">
                      <label className="filter_property_label">Price</label>
                      <div className="filter_input_div">
                        <input
                          type="range"
                          className="progress"
                          value={progress}
                          onChange={(e) => {
                            setProgress(e.target.value);
                          }}
                          style={{
                            marginTop: "10px",
                            background: `linear-gradient(to right, rgba(0, 51, 102, 1) 0%, rgba(0, 51, 102, 1) ${progress}%, rgb(231, 231, 231) ${progress}%,rgb(231, 231, 231) 100%)`,
                          }}
                        />
                        <div className="input_range_values">
                          <p>0 lakh</p>
                          <p>50 lakh</p>
                          <p>100 lakh</p>
                        </div>
                      </div>
                    </div>
                    {/* <div className="form_field_property">
                      <button className="apply_btn" onClick={handleSubmit}>
                        Apply
                      </button>
                    </div> */}
                  </form>
                </div>
              </div>
              {/* ) : (
                "no data"
              )} */}

              {propertyData.length > 0
                ? show && (
                    <>
                      <div
                        onClick={() => setshow(!show)}
                        className="modal_filter_div"
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          zIndex: "99",
                          height: "100vh",
                          position: "fixed",
                          top: "0",
                          left: "0",
                          backgroundColor: "rgba(0, 0, 0, 0.4)",
                        }}
                      ></div>
                      <div className="filter_property_div5">
                        <div className="filter_div_head">
                          <p className="filter_by_para">Filter by</p>
                          <p
                            className="clear_all_para"
                            style={{ cursor: "pointer" }}
                            onClick={handleClearAll}
                          >
                            Clear All
                          </p>
                        </div>
                        <div className="property_filter_form_wrapper">
                          <form>
                            <div className="form_field_property">
                              <label className="filter_property_label">
                                City
                              </label>
                              <div className="filter_input_div">
                                <select
                                  name="cityId"
                                  id="cityId"
                                  value={filterData?.cityId || ""}
                                  className="filter_input"
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      cityId: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="">Select Property Type</option>
                                  {city?.map((type) => (
                                    <option key={type?._id} value={type?._id}>
                                      {type?.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                Property Type
                              </label>
                              <div className="filter_input_div">
                                <select
                                  name="propertyType"
                                  id="propertyType"
                                  value={filterData?.propertyType || ""}
                                  className="filter_input"
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      propertyType: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="">Select Property Type</option>
                                  {propertyType.map((type) => (
                                    <option key={type._id} value={type._id}>
                                      {type.propertyType}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                Locality
                              </label>
                              <div className="filter_input_div">
                                <input
                                  className="filter_input"
                                  placeholder="Select an option"
                                  value={filterData.locality}
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      locality: e.target.value,
                                    }));
                                  }}
                                ></input>
                                {/* <img src={dropdown}></img> */}
                              </div>
                            </div>

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                Area
                              </label>
                              <div className="filter_input_div">
                                <input
                                  className="filter_input"
                                  placeholder="Select an option"
                                  value={filterData.area}
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      area: e.target.value,
                                    }));
                                  }}
                                ></input>
                                {/* <img src={dropdown}></img> */}
                              </div>
                            </div>

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                BHK
                              </label>
                              <div className="filter_input_div">
                                <select
                                  name="bhk"
                                  id="bhk"
                                  value={filterData?.bhk || ""}
                                  className="filter_input"
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      bhk: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="">Select BHK</option>
                                  {bhk.map((type) => (
                                    <option key={type._id} value={type._id}>
                                      {type.bhk}
                                    </option>
                                  ))}
                                </select>
                                {/* <input className='filter_input' placeholder='Select an option'></input>
                        <img src={dropdown}></img> */}
                              </div>
                            </div>

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                Address
                              </label>
                              <div className="filter_input_div">
                                <input
                                  className="filter_input"
                                  placeholder="Select an option"
                                  value={filterData.address}
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      address: e.target.value,
                                    }));
                                  }}
                                ></input>
                                {/* <img src={dropdown}></img> */}
                              </div>
                            </div>

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                Floor
                              </label>
                              <div className="filter_input_div">
                                <select
                                  name="floor"
                                  id="floor"
                                  value={filterData?.floor || ""}
                                  className="filter_input"
                                  onChange={(e) => {
                                    setFilterData((prevData) => ({
                                      ...prevData,
                                      floor: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="">Select Floor</option>
                                  {floor.map((type) => (
                                    <option key={type._id} value={type._id}>
                                      {type.floor}
                                    </option>
                                  ))}
                                </select>
                                {/* <input className='filter_input' placeholder='Select an option'></input>
                        <img src={dropdown}></img> */}
                              </div>
                            </div>

                            {/* <div className='form_field_property'>
                      <label className='filter_property_label'>Feature</label>
                      <div className='filter_input_div'>
                        <input className='filter_input' placeholder='Select an option'></input>
                        <img src={dropdown}></img>
                      </div>
                    </div> */}

                            <div className="form_field_property">
                              <label className="filter_property_label">
                                Price
                              </label>
                              <div className="filter_input_div">
                                <input
                                  type="range"
                                  className="progress"
                                  value={progress}
                                  onChange={(e) => {
                                    setProgress(e.target.value);
                                  }}
                                  style={{
                                    marginTop: "10px",
                                    background: `linear-gradient(to right, rgba(0, 51, 102, 1) 0%, rgba(0, 51, 102, 1) ${progress}%, rgb(231, 231, 231) ${progress}%,rgb(231, 231, 231) 100%)`,
                                  }}
                                />
                                <div className="input_range_values">
                                  <p>0 lakh</p>
                                  <p>50 lakh</p>
                                  <p>100 lakh</p>
                                </div>
                              </div>
                            </div>

                            {/* <div className='form_field_property'>
                      <label className='filter_property_label'>Facing</label>
                      <div className='filter_input_div'>
                        <input className='filter_input' placeholder='Select an option'></input>
                        <img src={dropdown}></img>
                      </div>
                    </div> */}

                            <div className="form_field_property">
                              <button
                                className="apply_btn"
                                onClick={handleSubmit}
                              >
                                Apply
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </>
                  )
                : ""}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivePropertyList;
